<template>
  <div v-if="loading" class="ui active inverted dimmer loader-margin">
    <div class="ui text loader">{{ $t('loading') }}...</div>
  </div>
  <div v-else>
    <pageHeader :headerIcon="'archive'"
                :headerText="$t('files')"
                :haveFilterInput="false">
    </pageHeader>

    <div v-if="filesData.length" style="padding-top: 20px">
      <abstractTable :columns="filesColumns"
                     :data="filesData"
                     :classes="'ui very compact left aligned very basic celled table'"
                     :dataPerPage="15" :paginationEnable="true"
                     :paginationFirstPageButtonText="$t('first')"
                     :paginationLastPageButtonText="$t('last')"
                     :paginationNextButtonText="$t('next')"
                     :paginationPervButtonText="$t('previous')"
                     style="padding-top: 20px">

        <template slot="table-column">
          <th width="10%" class="center aligned"> {{ $t('actions') }} </th>
        </template>

        <template slot="table-row-after" slot-scope="props">
          <td class="center aligned">
            <a :href="'http://localhost:3000' + props.row.attachment.url">
              {{ $t('download') }}
            </a>
          </td>
        </template>

      </abstractTable>
    </div>

    <div class="ui placeholder segment" style="margin-top: 70px !important;" v-else>
      <div class="ui icon header" style="color: #092442">
        <i class="dont icon"></i>
        {{ $t('noResumeHasBeenAddedYet') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable').default,
    pageHeader: require('@/components/abstract_components/PageHeader').default
  },
  data () {
    return {
      folders: [],
      loading: true
    }
  },
  mounted () {
    this.loading = true
    this.$http.get('folders').then(response => {
      this.folders = response.data
      this.loading = false
    })
  },
  computed: {
    filesColumns () {
      return [
        { header: this.$t('name'), fieldName: 'name', show: true }
      ]
    },
    filesData () {
      return window._.flatten(window._.map(this.folders, folder => { return folder.folder_files }))
    }
  }
}
</script>

<style scoped>
  /*.padding-header {
    padding-bottom: 20px;
  }*/
</style>



// WEBPACK FOOTER //
// src/components/folder/Files.vue